import { useEffect, useState } from "react";
import {
  getCurrentFinancialYear,
  isCurrentFinancialYear,
  listFiscalYears,
} from "../erpClient";

/**
 * Whether the session financial year is the active/current one.
 * Add/create actions should be disabled when this is false.
 */
export default function useIsCurrentFinancialYear() {
  const [isCurrent, setIsCurrent] = useState(() => isCurrentFinancialYear());

  useEffect(() => {
    let mounted = true;

    const sync = () => {
      if (!mounted) return;
      setIsCurrent(isCurrentFinancialYear());
    };

    const ensureList = async () => {
      if (getCurrentFinancialYear() == null) {
        try {
          await listFiscalYears();
        } catch {
          // keep optimistic allow until we know otherwise
        }
      }
      sync();
    };

    ensureList();
    window.addEventListener("financialYearUpdated", sync);
    return () => {
      mounted = false;
      window.removeEventListener("financialYearUpdated", sync);
    };
  }, []);

  return isCurrent;
}

export const FY_ADD_DISABLED_TITLE =
  "Switch to the current financial year to add entries";
